const t = (o) => o ? "" : void 0;
export {
  t as BoolStr
};
//# sourceMappingURL=bool.es.js.map
